/*!
 * Serialize all form data into an object of key/value pairs
 * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {Object}      The serialized form data
 */

/**
 *
 * @param {*} form
 * @returns
 */
export const serializeObject = function ( form ) {
	const obj = {};
	// eslint-disable-next-line func-names
	Array.prototype.slice.call( form.elements ).forEach( function ( field ) {
		// No fields that...
		if (
			// No name.
			!field.name ||
			// Disabled.
			field.disabled ||
			// Don't have values we care about.
			-1 < ['file', 'reset', 'submit', 'button'].indexOf( field.type ) ||
			// Empty values.
			'' === field.value.trim() ||
			// No autocompletes.
			'input-autocomplete' === field.name
		)
			return;
		// Handle multiselects differently.
		if ( 'select-multiple' === field.type ) {
			const options = [];
			// eslint-disable-next-line func-names
			Array.prototype.slice.call( field.options ).forEach( function ( option ) {
				if ( !option.selected ) return;
				options.push( option.value );
			} );
			if ( options.length ) {
				obj[field.name] = options;
			}
			return;
		}

		if ( -1 < ['checkbox', 'radio'].indexOf( field.type ) && !field.checked ) return;
		if ( 'checkbox' === field.type || field.name.endsWith( '[]' ) ) {
			const { name } = field;
			if ( !obj[name] ) {
				obj[name] = [];
			}

			obj[name].push( field.value );
		} else {
			// Add the rest.
			obj[field.name] = field.value;
		}
	} );

	return obj;
};

/**
 *
 * @param {*} objectToClean
 * @returns
 */
export const cleanObject = ( objectToClean ) => {
	const cleanedObject = { ...objectToClean };
	for ( const [key, value] of Object.entries( cleanedObject ) ) {
		if ( key.includes( '[]' ) ) {
			cleanedObject[key.replace( '[]', '' )] = value;
			delete cleanedObject[key];
		}
	}

	return cleanedObject;
};

/**
 * Emit a custom event.
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com.
 *
 * @param  {string} type   The event type.
 * @param  {Object} detail Any details to pass along with the event.
 * @param  {Node}   elem   The element to attach the event to.
 * @return {boolean}       The element dispatch event.
 */
export const emitEvent = ( type, detail = {}, elem = document ) => {
	// Make sure there's an event type
	if ( !type ) return false;

	// Create a new event
	const event = new CustomEvent( type, {
		bubbles: true,
		cancelable: true,
		detail,
	} );

	// Dispatch the event
	return elem.dispatchEvent( event );
};

/**
 * @source https://medium.com/swlh/how-to-use-recursion-to-flatten-a-javascript-object-17e43cc00159
 * @param {object} inputObject
 * @returns {object}
 */
export const flattenObject = ( inputObject ) => {
	const newObject = {};

	/**
	 *
	 * @param {*} currentObject
	 * @param {*} newObject
	 * @param {*} previousKeyName
	 */
	function flattenHelper( currentObject, newObject, previousKeyName ) {
		for ( const key in currentObject ) {
			const value = currentObject[key];

			if ( value.constructor !== Object ) {
				if ( null == previousKeyName || '' == previousKeyName ) {
					newObject[key] = value;
				} else {
					if ( null == key || '' == key ) {
						newObject[previousKeyName] = value;
					} else {
						newObject[`${previousKeyName}[${key}]`] = value;
					}
				}
			} else {
				if ( null == previousKeyName || '' == previousKeyName ) {
					flattenHelper( value, newObject, key );
				} else {
					flattenHelper( value, newObject, `${previousKeyName}[${key}]` );
				}
			}
		}
	}

	flattenHelper( inputObject, newObject, '' );

	return newObject;
};
